import { Field, FormGrid, FormWrapper, Title } from '../styled';

type BankData = {
  bank: string;
  account_number: string;
  agency: string;
  account_type: string; // você já usará "corrente"
};

interface StepBancariaProps {
  value: BankData;
  onChange: (data: BankData) => void;
}

export default function StepBancaria({ value, onChange }: StepBancariaProps) {
  const set = (k: keyof BankData, v: string) => onChange({ ...value, [k]: v });

  const formatConta = (value: string) =>
    value
      .replace(/\D/g, '')
      .slice(0, 9)
      .replace(/(\d{6})(\d)/, '$1-$2');

  const formatAgencia = (value: string) => value.replace(/\D/g, '').slice(0, 4);

  return (
    <FormWrapper>
      <Title>Conta para depósito</Title>

      <FormGrid>
        <Field style={{ gridArea: 'banco' }}>
          <label>Banco</label>
          <input
            placeholder='Ex: Itaú, Bradesco, Caixa...'
            value={value.bank}
            onChange={(e) => set('bank', e.target.value)}
          />
        </Field>

        <Field style={{ gridArea: 'conta' }}>
          <label>Número da conta corrente</label>
          <input
            value={value.account_number}
            onChange={(e) => set('account_number', formatConta(e.target.value))}
            placeholder='123456-7'
            inputMode='numeric'
          />
        </Field>

        <Field style={{ gridArea: 'agencia' }}>
          <label>Agência</label>
          <input
            value={value.agency}
            onChange={(e) => set('agency', formatAgencia(e.target.value))}
            placeholder='0242'
            inputMode='numeric'
          />
        </Field>
      </FormGrid>
    </FormWrapper>
  );
}
